import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {Subject} from "rxjs";
import {locale as polish} from "./i18n/pl";
import {locale as english} from "./i18n/en";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {first} from "rxjs/operators";
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialog} from "@angular/material/dialog";
import {StockService} from "../services/stock.service";
import {ActivatedRoute} from "@angular/router";
import {StockChangeService} from "../services/stockChange.service";
import {Product} from "../models/product";
import {SellingReport} from "../models/sellingReport";
import {SellingReportList} from "../models/sellingReportList";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {SellingReportService} from "../report/service/sellingReport.service";

@Component({
    templateUrl: './productSaleReport.component.html',
    styleUrls: ['./productSaleReport.component.scss']
})
export class ProductSaleReportComponent implements OnDestroy, OnInit {
    loadingIndicator: boolean;
    dateRange: FormGroup;
    deleteDialogRef: any;
    id: string;
    product: Product;
    totalSale: SellingReport;
    totalSaleByYear: SellingReportList;
    soldItems: SellingReportList;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private stockService: StockService,
        private stockChangeService: StockChangeService,
        private alertService: AlertService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private sellingReportService: SellingReportService,
        public _matDialog: MatDialog,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);

        this.id = this.route.snapshot.params['id'];
        this.product = this.route.snapshot.data.product;
        this.totalSale = this.route.snapshot.data.totalSale;
        this.totalSaleByYear = this.route.snapshot.data.totalSaleByYear;

        componentTitleService.clearTitle();
        componentTitleService.addPart('Products');
        componentTitleService.addPart(this.product.name);
        componentTitleService.addPart('Sale report');

        let today = new Date();
        let fromDate = new Date(today.setDate(today.getDate()-7));

        this.dateRange = new FormGroup({
            start: new FormControl(fromDate),
            end: new FormControl(today),
        });

        this.updateReport(this.convertDateToString(fromDate), this.convertDateToString(today));
    }

    updateReport(fromDate: string, toDate: string) {
        this.sellingReportService.getSoldProductByDateAndWorker(fromDate, toDate, this.id).pipe(first()).subscribe((res: SellingReportList) => {
            this.soldItems = res;
        });
    }

    convertDateToString(date: Date): string {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [date.getFullYear(),
            (mm>9 ? '' : '0') + mm,
            (dd>9 ? '' : '0') + dd
        ].join('-');
    };

    ngOnInit() {

    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    reloadStats(event: MatDatepickerInputEvent<any>) {
        let start;
        let end;

        try {
            start = this.dateRange.get('start').value.format('YYYY-MM-DD');
        } catch (e) {
            start = this.convertDateToString(this.dateRange.get('start').value);
        }

        try {
            end = this.dateRange.get('end').value.format('YYYY-MM-DD');
        } catch (e) {
            end = this.convertDateToString(this.dateRange.get('end').value);
        }

        this.updateReport(start, end);
    }
}
